import {
  Box,
  Flex,
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  Text,
  Heading,
  VStack,
  Button,
  Select,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import PageBanner from "../../../components/pageBanner/PageBanner";
import PageContainer from "../../../components/pageContainer/PageContainer";
import { getCertificatesRemaining } from "../../../slice/certificateIssuerHomeSlice";

import EventsInfoTable from "./EventsInfoTable";
import AdminApiKeys from "../adminHome/AdminApiKeys";
import IssuerScanStats from "./IssuerScanStats";

function CertificateIssuerHome() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedProduction, setSelectedProduction] = useState(null);

  const certsRemaining = useSelector((state) => state.certificateIssuerHome.certsRemaining);
  const accountInfo = useSelector((state) => state.certificateIssuerHome.accountInfo);
  const eventsInfo = useSelector((state) => state.certificateIssuerHome.eventsInfo.events);

  useEffect(() => {
    dispatch(getCertificatesRemaining());
  }, [dispatch]);

  useEffect(() => {
    if (eventsInfo?.length > 0 && !selectedProduction) {
      setSelectedProduction(eventsInfo[0]);
    }
  }, [eventsInfo, selectedProduction]);

  return (
    <PageContainer>
      <PageBanner />

      <Flex justify="center" width="100%">
        <Tabs width="100%" maxW="1200px" isLazy lazyBehavior="unmount">
          <TabList>
            <Tab>
              <Text color="#3483be" fontWeight="bold" fontSize={16}>
                Overview
              </Text>
            </Tab>

            <Tab>
              <Text color="#3483be" fontWeight="bold" fontSize={16}>
                Events
              </Text>
            </Tab>

            <Tab>
              <Text color="#3483be" fontWeight="bold" fontSize={16}>
                Scan Stats
              </Text>
            </Tab>

            <Tab>
              <Text color="#3483be" fontWeight="bold" fontSize={16}>
                API Keys
              </Text>
            </Tab>

            <Tab>
              <Text color="#3483be" fontWeight="bold" fontSize={16}>
                Accounts
              </Text>
            </Tab>
          </TabList>

          <TabPanels>
            {/* OVERVIEW */}
            <TabPanel>
              <VStack align="start" spacing={4}>
                {certsRemaining !== null && (
                  <Text fontWeight={600}>Certificates Remaining: {certsRemaining}</Text>
                )}
                {accountInfo?.sectorName && (
                  <Text fontWeight={600}>Sector: {accountInfo.sectorName}</Text>
                )}
              </VStack>
            </TabPanel>

            {/* EVENTS */}
            <TabPanel>
              <Flex justify="center">
                <Box width="100%" maxW="1100px">
                  <EventsInfoTable />
                </Box>
              </Flex>
            </TabPanel>

            {/* SCAN STATS */}
            <TabPanel>
              <VStack spacing={4} align="stretch">
                {eventsInfo?.length > 0 && (
                  <Select
                    value={selectedProduction?._id || ""}
                    onChange={(e) => {
                      const prod = eventsInfo.find((p) => p._id === e.target.value);
                      setSelectedProduction(prod);
                    }}
                  >
                    {eventsInfo.map((prod) => (
                      <option key={prod._id} value={prod._id}>
                        {prod.productionName} ({prod.year})
                      </option>
                    ))}
                  </Select>
                )}

                {selectedProduction?._id && (
                  <IssuerScanStats productionId={selectedProduction._id} />
                )}
              </VStack>
            </TabPanel>

            {/* API KEYS */}
            <TabPanel>
              <AdminApiKeys role="issuer" />
            </TabPanel>

            {/* ACCOUNTS */}
            <TabPanel>
              <Flex justify="center">
                <Box width="100%" maxW="400px">
                  <Heading size="md" mb={6} textAlign="center">
                    Account Management
                  </Heading>

                  <VStack spacing={4}>
                    <Button
                      bg="#007bff"
                      color="white"
                      width="100%"
                      size="md"
                      _hover={{ bg: "#2F6FE0" }}
                      _active={{ bg: "#2A63C7" }}
                      onClick={() => history.push("/issuer/accounts")}
                    >
                      Manage Child Accounts
                    </Button>

                    <Button
                      width="100%"
                      size="md"
                      variant="outline"
                      onClick={() => history.push("/issuer/accounts/create")}
                    >
                      Create Child Account
                    </Button>
                  </VStack>
                </Box>
              </Flex>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Flex>
    </PageContainer>
  );
}

export default CertificateIssuerHome;
